import React, { useEffect, useState } from 'react';
import { vehiclesAPI } from '../../services/api';
import { Field, Select } from './TyreFormControls';
import { useT } from '../../services/i18n';

export const EMPTY_VEHICLE = { brand: '', model: '', year: '', engine: '' };

const VehicleCascade = ({ value, onChange, onEngines }) => {
  const { t } = useT();
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [years, setYears] = useState([]);
  const [engines, setEngines] = useState([]);

  useEffect(() => { vehiclesAPI.getBrands().then(setBrands).catch(() => setBrands([])); }, []);
  useEffect(() => { setModels([]); if (value.brand) vehiclesAPI.getModels(value.brand).then(setModels).catch(() => setModels([])); }, [value.brand]);
  useEffect(() => { setYears([]); if (value.brand && value.model) vehiclesAPI.getYears(value.brand, value.model).then(setYears).catch(() => setYears([])); }, [value.brand, value.model]);
  useEffect(() => {
    setEngines([]);
    if (value.brand && value.model && value.year) vehiclesAPI.getEngines(value.brand, value.model, parseInt(value.year, 10)).then((e) => { setEngines(e); onEngines?.(e); }).catch(() => setEngines([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value.brand, value.model, value.year]);

  const set = (patch) => onChange({ ...value, ...patch });
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3" data-testid="vehicle-cascade">
      <Field label={t('tw.brand')}><Select value={value.brand} onChange={(b) => set({ brand: b, model: '', year: '', engine: '' })} options={brands} placeholder={t('tw.vc.pickBrand')} testId="vt-brand" /></Field>
      <Field label={t('tw.model')}><Select value={value.model} onChange={(m) => set({ model: m, year: '', engine: '' })} options={models} placeholder={value.brand ? t('tw.vc.pickModel') : t('tw.vc.selBrand')} testId="vt-model" /></Field>
      <Field label={t('tw.vc.year')}><Select value={value.year} onChange={(y) => set({ year: y, engine: '' })} options={years.map(String)} placeholder={value.model ? t('tw.vc.pickYear') : t('tw.vc.selModel')} testId="vt-year" /></Field>
      <Field label={t('tw.vc.engine')}><Select value={value.engine} onChange={(e) => set({ engine: e })} options={engines.map((e) => [e.name, `${e.name} · ${e.power} ${t('tw.vc.hp')}`])} placeholder={value.year ? t('tw.vc.allEngines') : t('tw.vc.selYear')} testId="vt-engine" /></Field>
    </div>
  );
};

export default VehicleCascade;
